import { getListTag, getOptional, getTag } from '../nbt/index.js';
import { BlockState } from './BlockState.js';
export class Structure {
    size;
    palette;
    blocks;
    blocksMap = [];
    constructor(size, palette = [], blocks = []) {
        this.size = size;
        this.palette = palette;
        this.blocks = blocks;
        blocks.forEach(block => {
            if (!this.isInside(block.pos)) {
                throw new Error(`Found block at ${block.pos} which is outside the structure bounds ${this.size}`);
            }
            this.blocksMap[block.pos[0] * size[1] * size[2] + block.pos[1] * size[2] + block.pos[2]] = block;
        });
    }
    getSize() {
        return this.size;
    }
    addBlock(pos, name, properties, nbt) {
        if (!this.isInside(pos)) {
            throw new Error(`Cannot add block at ${pos} outside the structure bounds ${this.size}`);
        }
        const blockState = new BlockState(name, properties);
        let state = this.palette.findIndex(b => b.equals(blockState));
        if (state === -1) {
            state = this.palette.length;
            this.palette.push(blockState);
        }
        this.blocks.push({ pos, state, nbt });
        this.blocksMap[pos[0] * this.size[1] * this.size[2] + pos[1] * this.size[2] + pos[2]] = { pos, state, nbt };
        return this;
    }
    getBlocks() {
        return this.blocks.map(b => ({
            pos: b.pos,
            state: this.palette[b.state],
            nbt: b.nbt,
        }));
    }
    getBlock(pos) {
        if (!this.isInside(pos))
            return null;
        const block = this.blocksMap[pos[0] * this.size[1] * this.size[2] + pos[1] * this.size[2] + pos[2]];
        if (!block)
            return null;
        const placedBlock = {
            pos: block.pos,
            state: this.palette[block.state],
            nbt: block.nbt,
        };
        return placedBlock;
    }
    isInside(pos) {
        return pos[0] >= 0 && pos[0] < this.size[0]
            && pos[1] >= 0 && pos[1] < this.size[1]
            && pos[2] >= 0 && pos[2] < this.size[2];
    }
    static fromNbt(nbt) {
        const size = getListTag(nbt.value, 'size', 'int', 3);
        const palette = getListTag(nbt.value, 'palette', 'compound')
            .map(tags => BlockState.fromNbt({ name: '', value: tags }));
        const blocks = getListTag(nbt.value, 'blocks', 'compound')
            .map(tags => {
            const pos = getListTag(tags, 'pos', 'int', 3);
            const state = getTag(tags, 'state', 'int');
            const nbt = getOptional(() => getTag(tags, 'nbt', 'compound'), undefined);
            return { pos, state, nbt };
        });
        return new Structure(size, palette, blocks);
    }
}
//# sourceMappingURL=Structure.js.map